<div class="holder">
  <div class="image">
    <img [alt]="name" [src]="imageUrl">
  </div>

  <div class="data">
    @if (name) {
      <h2>{{ name }}</h2>
    }

    @if (askingPrice) {
      <p>Utropspris: {{ askingPrice | number: '1.0-0' : 'fr' }}</p>
    }

    @if (area) {
      <p>Boarea: {{ area | number: '1.0-0' : 'fr' }} kvm</p>
    }

    @if (year) {
      <p>Byggår: {{ year }}</p>
    }

    @if (fee) {
      <p>Avgift: {{ fee | number: '1.0-0' : 'fr' }} kr/mån</p>
    }
  </div>
</div>
